/** URLs for files under `public/` (served from site root). Use with `process.env.PUBLIC_URL` for subpath deployment. */
export function publicUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const base = process.env.PUBLIC_URL ?? "";
  return `${base}${normalized}`;
}

/** Same asset as `public/index.html` favicon and apple-touch-icon. */
export const faviconUrl = publicUrl("/assets/images/logos/netshield-logo.png");

export const loginLogoUrl = faviconUrl;

export const sidebarBrandIconUrl = faviconUrl;

/**
 * Icon + "NetShield" wordmark as a transparent PNG. Login, OTP, Forgot Password, and the
 * admin sidebar all use this file so auth and the dashboard render the same branding.
 */
export const primaryLogoPngUrl = publicUrl(
  "/assets/images/logos/primary-logo.png",
);

/**
 * Subtle diamond watermark used behind the client app's sign-in screen — reused here so both
 * apps' auth pages share the same look. Applied via inline `style`, not a CSS Module `url()`:
 * CRA's css-loader tries to resolve a root-relative `url(/...)` as a webpack module relative to
 * the CSS file's own folder (not the `public/` dir) and fails to find it, especially on Windows
 * where a leading `/` isn't a real filesystem-absolute path.
 */
export const authBackgroundPatternUrl = publicUrl(
  "/assets/images/backgrounds/auth-pattern.png",
);
